import {
  Component,
  HostListener,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-file-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: UploadComponent,
      multi: true,
    },
  ],
})
export class UploadComponent implements OnChanges, ControlValueAccessor {
  fileName: string;
  @Input() progress;
  @Input() placeholder;
  @Input() elementId;
  onChange: Function;
  @Input() file: any | null = null;
  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
    const file = event && event.item(0);
    this.onChange(file);
    this.file = file;
  }

  constructor(private host: ElementRef<HTMLInputElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.file) {
      this.getFileName();
    }
  }

  getFileName() {
    if (typeof this.file === 'string') {
      this.fileName = this.file;
    } else if (this.file?.name) {
      this.fileName = this.file.name;
    } else {
      this.fileName = this.placeholder;
    }
  }

  writeValue(value: null) {
    // clear file input
    this.host.nativeElement.value = '';
    this.file = null;
  }

  registerOnChange(fn: Function) {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function) {}
}
